var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex align-center"},[(!_vm.hideBack)?_c('back',{staticClass:"mt-1"}):_vm._e(),_vm._v(" "),_vm._t("actions")],2),_c('v-divider',{staticClass:"mb-5 mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }